import { CardFieldsContainer } from 'payments/components/CardFieldsContainer';
import useCommerceHub from 'payments/hooks/useCommerceHub';
import { CommerceHubPaymentFormProvider } from 'payments/providers/CommerceHubPaymentFormProvider';
import { PaymentInformationProps } from 'reservations/payments/types';

export function CommerceHubPaymentInformation({
  children
}: React.PropsWithChildren<PaymentInformationProps>) {
  const { cardFieldStates, handleCardSubmit } = useCommerceHub();

  return (
    <CommerceHubPaymentFormProvider handleCardSubmit={handleCardSubmit}>
      <CardFieldsContainer cardFieldStates={cardFieldStates} />
      {children}
    </CommerceHubPaymentFormProvider>
  );
}
